module.exports = __webpack_public_path__ + "img/pro_emm_02.6e979bc6.png";